import React from 'react';
import Link from 'next/link';
import { Cursor } from '@/components/shared/icons';

type Props = {
    href: string;
    text?: string;
    iconColor?: string;
    children?: React.ReactNode;
}

const CustomLink = ({ href, text, iconColor = 'fill-primary-yellow-400', children }: Props) => {
    return (
        <Link href={href} className='w-fit flex justify-between items-center gap-x-2 icon-box'>
            <div className="border border-primary-gray-950 rounded-lg p-2">
                <Cursor color={iconColor} />
            </div>

            {text ? <span className='text-primary-gray-950 underline'>{text}</span> : (
                children
            )}
        </Link>
    );
}

export default CustomLink;